import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const HeaderRlt1 = () => {
  return <header className="bg-white" data-id="element-18094">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-18095"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-18096">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-18097">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-18098">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-18099">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex justify-start mb-3" data-id="element-18100">
          <div className="text-xs text-gray-400 font-sans" data-id="element-18101">Advertorial 1</div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-18102">
          <div className="text-left" data-id="element-18103">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-18104">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-18105">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-18106">
        <div className="max-w-4xl mx-auto" data-id="element-18107">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-18108">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-18109">
            PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat
            Loss a Scam—Or Are Most Devices Just Built Wrong?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-18110">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-18111">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell" className="w-full h-full object-cover" data-id="element-18112" />
            </div>
            <div className="flex-1" data-id="element-18113">
              <div className="flex items-center" data-id="element-18114">
                <div className="font-medium text-gray-900 text-lg" data-id="element-18115">
                  By Dr. Sarah Mitchell, PhD
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-18116">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-18117" />
                  <span className="text-xs ml-1 font-medium" data-id="element-18118">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-18119">
                Exercise Physiology, University of Texas
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-18120">
                <div className="flex items-center mr-4" data-id="element-18121">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-18122" />
                  <span data-id="element-18123">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-18124">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-18125" />
                  <span data-id="element-18126">47,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-18127">
            An Independent Analysis by Dr. Sarah Mitchell, PhD | Exercise
            Physiology. Updated: January 2026
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-18128">
            <div className="mb-1 flex items-center" data-id="element-18129">
              <span className="font-medium mr-2" data-id="element-18130">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-18131">
              <span className="font-medium mr-2" data-id="element-18132">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-18133">
        <div className="max-w-4xl mx-auto" data-id="element-18134">
          <div className="sm:flex items-center" data-id="element-18135">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-18136">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell in research lab" className="w-full rounded-lg shadow-md" data-id="element-18137" />
            </div>
            <div className="sm:w-2/3" data-id="element-18138">
              <p className="text-sm text-gray-700 mb-2" data-id="element-18139">
                <span className="font-bold" data-id="element-18140">Dr. Sarah Mitchell, PhD</span> has
                spent 25 years in exercise physiology research and clinical
                practice. With a doctorate from the University of Texas, she has
                published extensively on metabolic adaptation and body
                composition.
              </p>
              <p className="text-sm text-gray-700" data-id="element-18141">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderRlt1;